import { Card } from "./components";
import { GIT_CARDS } from "./constants/GitCard.constants";
import "./styles/git_cards.scss";

const GitCard = () => {
  return (
    <div id="git-cards">
      <div className="container mb-5 pb-5">
        <div className="title mb-3">
          <h6 className="text-center font_change_color">Accounts</h6>
          <h1 className="text-center">My account profiles</h1>
        </div>
        <div className="row display-flex justify-content-center m-0">
          {GIT_CARDS?.map(({ order, ...card }, index) => (
            <div className={`col-12 col-sm-6 col-md-4 ${order}`} key={index}>
              <Card {...card} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GitCard;
